export default __webpack_public_path__ + "static/media/retailer.24a1fd48.svg";